import { Reveal } from "./Reveal";
import { GoldLink } from "./Buttons";

export const CTABanner = ({
  title = "Ready when you are.",
  sub = "Tell us what you're making — we'll bring the crew, the plan, and the calm.",
}) => (
  <section data-testid="cta-banner" className="bg-night text-sand">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-8 sm:py-28 lg:px-16">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold">Start a Project</p>
        <h2 className="headline mt-4 max-w-3xl font-display text-3xl font-bold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          {title}
        </h2>
        <p className="mt-5 max-w-xl font-serif text-lg italic text-sand/60 sm:text-2xl">{sub}</p>
        <div className="mt-9">
          <GoldLink to="/start-a-project" testId="cta-banner-start-project">
            Start a Project
          </GoldLink>
        </div>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-sand/35">
          Inquiries run through HoneyBook · Reply within one business day
        </p>
      </Reveal>
    </div>
  </section>
);
